import { Directive, OnInit, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { filter, map, tap } from 'rxjs/operators';

@Directive({
    selector: '[filterInput]',
})
export class FilterInputDirective implements OnInit {
  private _control = inject(NgControl);


  readonly filter = input('');

  ngOnInit() {
    if (!this._control) {
      throw new Error('You should specify formControlName on your input element!');
    }

    const filterValue = this.filter();
    if (!filterValue) {
      throw new Error('You should provide [filter] string of unacceptable chars');
    }

    const regex = new RegExp(`[${filterValue}]`, 'g');

    /**
     * Remove unacceptable characters from input
     */
    this._control?.control?.valueChanges.pipe(
      map(value => [value, value.replace(regex, '')]),
      filter(([prev, current]) => prev !== current),
      tap(([prev, current]) => this._control?.control?.setValue(current, {
        emitEvent: false
      }))
    ).subscribe();
  }

}
